<template>
    <div>
        
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-4">
            <div class="col">
                <input type="text" placeholder="N° Ticket" class="" v-model="PesNro">
                <button class="btn btn-sm btn-success ml-2" @click="buscar">Buscar</button>
            </div>
            <div class="col">
                <button class="btn btn-danger" :disabled="!neto_final" @click="update">update</button>
            </div>
        </div>
                        <div class="row">
                            <div class="col">
                                <h2>ETRUCK</h2>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <table class="table table-striped table-bordered">
                            <thead>
                                <th>Fecha Peso Bruto</th>
                                <th>Fecha Peso Tara</th>
                                <th>Peso Bruto</th>
                                <th>Peso Bruto S/Envase</th>
                                <th>Peso Tara</th>
                                <th>Peso Tara S/Envase</th>
                                <th>Peso Neto</th>
                                <th>Peso Neto Corregido</th>
                            </thead>
                            <tbody>
                                <td>
                                    <input type="text" v-model="ticket.fecha_peso_bruto">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.fecha_peso_tara">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_total_bruto">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_bruto_sin_envases">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_tara">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_tara_sin_envases">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_neto">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket.peso_neto_corregido">
                                </td>
                            </tbody>
                        </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <h2>MODIFICADO</h2>
                            </div>
                        </div>
                        <div class="row mb-4">
                            <table class="table table-striped table-bordered">
                            <thead>
                                <th>Fecha Peso Bruto</th>
                                <th>Fecha Peso Tara</th>
                                <th>Peso Bruto</th>
                                <th>Peso Bruto S/Envase</th>
                                <th>Peso Tara</th>
                                <th>Peso Tara S/Envase</th>
                                <th>Peso Neto</th>
                                <th>Peso Neto Corregido</th>
                            </thead>
                            <tbody>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesComFec">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesTarFec">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesTotComBru">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesVhcComBru">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesTotTar">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesVhcTar">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesVhcComNet">
                                </td>
                                <td>
                                    <input type="text" v-model="ticket_cal.PesVhcComNetCor">
                                </td>
                            </tbody>
                        </table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p>Peso Neto Final</p>
                                <input class="mb-4" type="text" v-model="neto_final">

                                <p>Peso a Modificar: {{radio}}</p>
                                <input type="radio" :value="1" name="radio" v-model="radio" class="mr-2">
                                <label for="radio1">Peso Bruto</label><br>
                                <input type="radio" :value="2" name="radio" v-model="radio" class="mr-2">
                                <label for="radio2">Peso Tara</label>
                                
                            </div>
                            <div class="col">
                                <pre>{{ticket_cal}}</pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <json-viewer
                :value="jsonData"
                :expand-depth=5
                ></json-viewer>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data:()=>({
        PesNro:null,
        jsonData:{},
        radio:1,
        neto_final:null,
        ticket:{}
    }),
    methods:{
        async buscar(){
            await this.axios.get(`${this.api}/consulta_etruck/${this.PesNro}`,this.cabeceras_json).then(r => {
                this.jsonData = r.data.data;
                this.ticket = r.data.data.ticket;
                this.neto_final = null;
                this.radio = 1;
            }).catch(e =>{
                console.log(e);
            });
        },

        async update(){
            await this.axios.post(`${this.api}/consulta_etruck/${this.ticket.codigo_ticket}/update`,this.ticket_cal,this.cabeceras_json).then(r => {
                console.log('updated',r.data);
            }).catch(e => {
                console.log(e);
            })
        },
    },
    computed:{
        ticket_cal(){
            let t = {
                PesComFec:this.ticket.fecha_peso_bruto,
                PesTarFec:this.ticket.fecha_peso_tara,
                PesTotComBru:null,
                PesVhcComBru:null,
                PesTotTar:null,
                PesVhcTar:null,
                PesVhcComNet:null,
                PesVhcComNetCor:null
            }
            let diferencia = null;
            if(this.neto_final < this.ticket.peso_neto_corregido){
                diferencia = this.ticket.peso_neto_corregido - this.neto_final;
            }else{
                diferencia = this.neto_final - this.ticket.peso_neto_corregido;
            }
            console.log(typeof diferencia);
            if(this.neto_final){
                if(this.radio == 1){
                    //modificar peso bruto
                    if(this.neto_final < this.ticket.peso_neto_corregido){
                        t.PesTotComBru = Number(this.ticket.peso_total_bruto) - diferencia
                        t.PesVhcComBru = Number(this.ticket.peso_bruto_sin_envases) - diferencia
                    }else{
                        t.PesTotComBru = Number(this.ticket.peso_total_bruto) + diferencia
                        t.PesVhcComBru = Number(this.ticket.peso_bruto_sin_envases) + diferencia
                    }
                    t.PesTotTar = Number(this.ticket.peso_tara);
                    t.PesVhcTar = Number(this.ticket.peso_tara_sin_envases);

                    
                }

                if(this.radio == 2){
                    if(this.neto_final < this.ticket.peso_neto_corregido){
                        t.PesTotTar = Number(this.ticket.peso_tara) + diferencia
                        t.PesVhcTar = Number(this.ticket.peso_tara_sin_envases) + diferencia
                    }else{
                        t.PesTotTar = Number(this.ticket.peso_tara) - diferencia
                        t.PesVhcTar = Number(this.ticket.peso_tara_sin_envases) - diferencia
                    }

                    t.PesTotComBru = Number(this.ticket.peso_total_bruto);
                    t.PesVhcComBru = Number(this.ticket.peso_bruto_sin_envases);

                }

                t.PesVhcComNet = t.PesVhcComBru - t.PesTotTar;
                t.PesVhcComNetCor = t.PesVhcComBru - t.PesVhcTar;
            }
            return t;
        },
        ...mapState(['api','cabeceras_json'])
    }
}
</script>